import React from "react";
import * as PropTypes from "prop-types";
import { titlesPropType } from "../../propTypes";
import { formatValue } from "../../utilities";
import { withStyles } from "@material-ui/core/styles";
import classNames from "classnames";
import styles from "./tableStyles";

const getTitles = (titles, classes, superTitles) => (
  <tr>
    {titles.map(
      ({ key, title, columnSpan, majorGroup, groupStart, groupEnd, total }) => (
        <th
          key={key || title}
          colSpan={columnSpan}
          dangerouslySetInnerHTML={{
            __html: title
          }}
          className={classNames(
            classes.center,
            classes.title,
            superTitles && title ? classes.superTitle : undefined,
            groupStart
              ? majorGroup
                ? classes.majorGroupStart
                : classes.groupStart
              : undefined,
            groupEnd
              ? majorGroup
                ? classes.majorGroupEnd
                : classes.groupEnd
              : undefined,
            total ? classes.totalColumn : undefined,
            classes.cell
          )}
        />
      )
    )}
  </tr>
);

const getTotals = (columnKey, columnValue, rowKey, rowValue, data) =>
  data
    .filter(
      datum => datum[columnKey] === columnValue && datum[rowKey] === rowValue
    )
    .reduce((result, datum) => (result || 0) + datum.value, undefined);

const PivotTable = props => (
  <div className={classNames("PivotTable", props.classes.container)}>
    <table className={props.classes.table}>
      <thead>
        {props.superTitles && getTitles(props.superTitles, props.classes, true)}
        {props.titles && getTitles(props.titles, props.classes, false)}
        <tr>
          <th className={props.classes.heading} />
          {props.columnDefinitions.map(columnDefinition => (
            <th
              key={columnDefinition.value}
              dangerouslySetInnerHTML={{
                __html: columnDefinition.label || columnDefinition.value
              }}
              className={classNames(
                props.classes.heading,
                columnDefinition.groupStart
                  ? columnDefinition.majorGroup
                    ? props.classes.majorGroupStart
                    : props.classes.groupStart
                  : undefined,
                columnDefinition.groupEnd
                  ? columnDefinition.majorGroup
                    ? props.classes.majorGroupEnd
                    : props.classes.groupEnd
                  : undefined,
                columnDefinition.total ? props.classes.totalColumn : undefined,
                props.classes.cell,
                props.classes.center
              )}
            />
          ))}
        </tr>
      </thead>
      <tbody>
        {props.rowDefinitions.map((rowDefinition, rowIndex) => (
          <tr
            key={rowDefinition.value}
            className={
              rowDefinition.current ? props.classes.currentYear : undefined
            }>
            <td
              className={classNames(
                rowIndex ? props.classes.row : undefined,
                props.classes.cell,
                rowDefinition.total ? props.classes.totalRow : undefined
              )}>
              {rowDefinition.label || rowDefinition.value}
            </td>
            {props.columnDefinitions.map(columnDefinition => {
              const totals = getTotals(
                props.columnKey,
                columnDefinition.value,
                props.rowKey,
                rowDefinition.value,
                props.data
              );

              return (
                <td
                  key={columnDefinition.value}
                  className={classNames(
                    rowIndex ? props.classes.row : undefined,
                    props.classes.cell,
                    rowDefinition.total ? props.classes.totalRow : undefined,
                    columnDefinition.groupStart
                      ? columnDefinition.majorGroup
                        ? props.classes.majorGroupStart
                        : props.classes.groupStart
                      : undefined,
                    columnDefinition.groupEnd
                      ? columnDefinition.majorGroup
                        ? props.classes.majorGroupEnd
                        : props.classes.groupEnd
                      : undefined,
                    columnDefinition.total
                      ? props.classes.totalColumn
                      : undefined,
                    isNaN(totals) ? props.classes.center : props.classes.right
                  )}>
                  {formatValue(
                    totals,
                    columnDefinition.percentage || rowDefinition.percentage,
                    props.na
                  )}
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

PivotTable.propTypes = {
  superTitles: titlesPropType,
  titles: titlesPropType,
  columnKey: PropTypes.string.isRequired,
  columnDefinitions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string.isRequired,
      percentage: PropTypes.bool,
      majorGroup: PropTypes.bool,
      groupStart: PropTypes.bool,
      groupEnd: PropTypes.bool,
      total: PropTypes.bool
    })
  ),
  rowKey: PropTypes.string.isRequired,
  rowDefinitions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string.isRequired,
      percentage: PropTypes.bool,
      current: PropTypes.bool,
      total: PropTypes.bool
    })
  ),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired
    })
  ),
  na: PropTypes.string
};

PivotTable.defaultProps = {
  na: "n/a"
};

export default withStyles({
  ...styles,
  center: {
    textAlign: "center"
  }
})(PivotTable);
